import React, {useState, useEffect, useContext, useRef} from "react";
import {store} from '../../context/store';
import {functions} from "../../constants/common-functions";
import { colorFunctions, OMNISCAN_BLUE } from "../../constants/colors";
import {useHistory} from 'react-router-dom';
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import {nonStandardUtilisationUrls} from "../../constants/client-specifics";
import {COLOR_FOCUS} from "../../constants/general-constants";
import {COLOR_EDIT} from "../../constants/general-constants";
import {COLOR_MEETING} from "../../constants/general-constants";
import {COLOR_ALTERNATIVE} from "../../constants/general-constants";
import {COLOR_SOCIAL} from "../../constants/general-constants";
import UtilisationSpaceTypeHeader from "./components/UtilisationSpaceTypeHeader";
import UtilisationSummaryRow from "./components/UtilisationSummaryRow";
import UtilisationFooter from "../../pages/utilisation/components/UtilisationFooter";
import {EMPTY_FILTER_BEAN} from "../../constants/filter-constants";
import MobileHomeUtilisation
from "./mobile/MobileHomeUtilisation";

export default function HomeUtilisation(){
	
	const history = useHistory();
	
	const [componentHeight, setComponentHeight] = useState(80);
	
	const searchId = useRef(null);
	
	const [thisBackground, setThisBackground] = useState("");
	const [thisRed, setThisRed] = useState("");
	const [lightBlue, setLightBlue] = useState("");
	const [thisGradient, setThisGradient] = useState("");
	const [clientLogo, setClientLogo] = useState("");
	
	const [workstationsFocus, setWorkstationsFocus] = useState("");
	const [workstationsEdit, setWorkstationsEdit] = useState("");
	const [workstationsMeeting, setWorkstationsMeeting] = useState("");
	const [workstationsAlternative, setWorkstationsAlternative] = useState("");
	const [workstationsSocial, setWorkstationsSocial] = useState("");
	
	const [observationsFocus, setObservationsFocus] = useState("");
	const [observationsEdit, setObservationsEdit] = useState("");
	const [observationsMeeting, setObservationsMeeting] = useState("");
	const [observationsAlternative, setObservationsAlternative] = useState("");
	const [observationsSocial, setObservationsSocial] = useState("");
	
	const [averageFocus, setAverageFocus] = useState("");
	const [averageEdit, setAverageEdit] = useState("");
	const [averageMeeting, setAverageMeeting] = useState("");
	const [averageAlternative, setAverageAlternative] = useState("");
	const [averageSocial, setAverageSocial] = useState("");
	
	const [peakFocus, setPeakFocus] = useState("");
	const [peakEdit, setPeakEdit] = useState("");
	const [peakMeeting, setPeakMeeting] = useState("");
	const [peakAlternative, setPeakAlternative] = useState("");
	const [peakSocial, setPeakSocial] = useState("");
	const [loaded, setLoaded] = useState(false);
	
	
	const isMobile =
	    window.innerWidth <= 768;
	
	const globalState = useContext(store);
	
	const filterBean = {};
	
	const queryContext =
		    globalState?.state?.queryContext;

	useEffect(() => {

	    if (nonStandardUtilisationUrls.includes(window.location.hostname)) {
	        history.push('/utilisationallnonstandard/-100');
	    }

	    setThisBackground(colorFunctions.getPrimaryColor());
	    setThisRed(colorFunctions.getPrimaryAlternative());

	    functions.getArrayFromAjax(
	        "/resolutionsoftwareplatform/getclient",
	        null,
	        setColors
	    );

	}, []);
	
	useEffect(() => {
		loadDashboard();
	}, [	queryContext?.utilisationSurveyId,
	        loaded]);
	
	const loadDashboard = () => {
		functions.postFilterBeanAjax(
		           "/resolutionsoftwareplatform/utilisationsummary/published",
		           functions.buildPostBodyFilterBeanQueryContext(filterBean, queryContext),
		           handleUtilisationHomeComponent
		       );
	}
	
	
	const handleUtilisationHomeComponent = (obj) => {
		
		console.log(obj);
		
		if(obj.meetingAverage){
			setAverageMeeting(functions.formatNumber(obj.meetingAverage, 1) + '%');
		}
		
		if(obj.socialAverage){
			setAverageSocial(functions.formatNumber(obj.socialAverage, 1) + '%');
		}
		
		if(obj.technicalAverage){
			setAverageEdit(functions.formatNumber(obj.technicalAverage, 1) + '%');
		}
		
		if(obj.alternativeAverage){
			setAverageAlternative(functions.formatNumber(obj.alternativeAverage, 1) + '%');
		}
		
		if(obj.dashboardHomeUtilisationGroupAverage){
			let thisObj = obj.dashboardHomeUtilisationGroupAverage;
			setAverageFocus(functions.formatNumber(thisObj.focus, 1) + '%');
			//setAverageEdit(functions.formatNumber(thisObj.edit, 1) + '%');
			//setAverageMeeting(functions.formatNumber(thisObj.meeting, 1) + '%');
			//setAverageAlternative(functions.formatNumber(thisObj.alternative, 1) + '%');
			//setAverageSocial(functions.formatNumber(thisObj.social, 1) + '%');
		}
		if(obj.dashboardHomeUtilisationGroupPeak){
			let thisObj = obj.dashboardHomeUtilisationGroupPeak;
			setPeakFocus(functions.formatNumber(thisObj.focus, 1) + '%');
			setPeakEdit(functions.formatNumber(thisObj.edit, 1) + '%');
			setPeakMeeting(functions.formatNumber(thisObj.meeting, 1) + '%');
			setPeakAlternative(functions.formatNumber(thisObj.alternative, 1) + '%');
			setPeakSocial(functions.formatNumber(thisObj.social, 1) + '%');
		}
		if(obj.dashboardHomeUtilisationGroupObservations){
			let thisObj = obj.dashboardHomeUtilisationGroupObservations;
			setObservationsFocus(functions.formatNumber(thisObj.focus, 0));
			setObservationsEdit(functions.formatNumber(thisObj.edit, 0));
			setObservationsMeeting(functions.formatNumber(thisObj.meeting, 0));
			setObservationsAlternative(functions.formatNumber(thisObj.alternative, 0));
			setObservationsSocial(functions.formatNumber(thisObj.social, 0));
		}
		if(obj.dashboardHomeUtilisationGroupWorkstations){
			let thisObj = obj.dashboardHomeUtilisationGroupWorkstations;
			setWorkstationsFocus(functions.formatNumber(thisObj.focus, 0));
			setWorkstationsEdit(functions.formatNumber(thisObj.edit, 0));
			setWorkstationsMeeting(functions.formatNumber(thisObj.meeting, 0));
			setWorkstationsAlternative(functions.formatNumber(thisObj.alternative, 0));
			setWorkstationsSocial(functions.formatNumber(thisObj.social, 0));
		}
		
	};
	
	const setColors = (client) => {
		let logoSource = client.resourceFolderUrl + "/client_logo.png";
			functions.getFileSource(logoSource,
				setClientLogo, null);
		sessionStorage.setItem("colorPrimary", client.colorPrimary);
		sessionStorage.setItem("colorSecondary", client.colorSecondary);
		sessionStorage.setItem("colorGradient", client.colorGradient);
		setThisGradient(client.colorGradient);
	};
  
  
  const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	height:"100vh",
  	left:"0px",
  	top:"0px",
  	//background: "linear-gradient(180deg, #f4f6fb 0%, #ffffff 40%, #f4f6fb 100%)",
  };
  
  
  const header =
  {
      display:
          "flex",
      position:
          "fixed",
      width:
          "700px",
      left:
          "calc(50% - 350px)",
      top:
          "0px",
      zIndex:
          30000,
      justifyContent:
          "center",
      alignItems:
          "center",
      height:
          "50px",

      //--------------------------------------------------------
      // OmniScan Flat title bar
      //--------------------------------------------------------
      background:
          "linear-gradient(180deg,#171b20 0%,#0c0f12 100%)",

      borderRadius:
          "0px",

      borderLeft:
          "1px solid rgba(255,255,255,0.06)",

      borderRight:
          "1px solid rgba(255,255,255,0.06)",

     borderBottom: `2px solid ${OMNISCAN_BLUE}`,

      boxShadow:
          "0 8px 20px rgba(0,0,0,0.20)",

      overflow:
          "hidden"
  };
  
  const logoStyle = {
  	display:"flex",
  	maxHeight:"70px",
  	marginLeft:"12px",
  	marginTop:"12px"
  };
  
  const titleContainer = {
  	display:"flex",
  	alignItems:"center",
  	marginRight:"0px",
  	fontSize:'16px',
	color:'lightgrey'

  };
  
  const footer = {
		position:"fixed",
		display:"flex",
		right:"0px",
		bottom:"0px",
		padding:"20px",
		paddingTop:"10px",
		paddingBottom:"10px",
		alignItems:"center",
		backgroundColor:"white",
		borderTopLeftRadius:"20px",
		background:"linear-gradient(180deg,#2b2f34 0%,#1c1f23 100%)",
	};
	
	const omniscanLogoStyle = {
		display:"flex",
		width:"230px",
		marginLeft:"50px",
		marginRight:"50px",
		marginTop:"2px"
	};
	
	const omniscan = {
		display:'flex',
		fontSize:"21px",
		color:'black'
	};
	
	const by = {
		display:'flex',
		fontSize:"21px",
		color:'black',
		marginLeft:"10px",
		marginRight:"10px"
	};
	
	const pro = {
		display:'flex',
		fontSize:"21px",
		color:thisRed,
		
	};
	
	
	const mainContent = {
		display:"flex",
		width:"calc(100% - 60px)",
		flexDirection:"column",
		marginTop:"100px",
		marginLeft:"60px",
		zIndex:2
	};
	
	const headerRow ={
		display:"flex",
		width:"calc(100% - 320px)",
		paddingLeft:"20px",
		marginLeft:"300px",
		
	};
	
	
	const headerIcon = {
		display:"flex",
		width:"40px",
		height:"40px",
		color:"white",
		marginLeft:"20px",
		cursor:'pointer'
	};
	
	const headerTitle = {
		display:"flex",
		color:"white",
		fontSize:"16px",
		marginLeft:"20px"
	};
	
	const contentRow = {
		display: "flex",
		width: "calc(100% - 80px)",
		marginTop: "20px",
		marginLeft: "40px",
		borderRadius: "12px",
		backgroundColor:'white',
		background: "linear-gradient(180deg, #FAFBFD 0%, #ECEFF3 100%)",

		boxShadow: `
			0 10px 24px rgba(0,0,0,0.10),
			0 2px 6px rgba(0,0,0,0.10)
		`
	};
	
	const contentBox = {
		display: "flex",
		height: "100%",
		alignItems: "center",
		width: "270px",

		background: "linear-gradient(180deg, #3F4550 0%, #2C3037 100%)",

		borderTopLeftRadius: "12px",
		borderBottomLeftRadius: "12px",

		boxShadow: "inset -1px 0 0 rgba(255,255,255,0.08)"
	};
	
	const contentFigureContainerHighlight = {
		display:'flex',
		marginLeft:"40px",
		height:(componentHeight + 4) + "px",
		borderRadius:"10px",
		width:"calc(100% - 200px)",
		alignItems:"center"
	};
	
	
	
	const contentFigure = {
		display:"flex",
		width:"calc(100% - 40px)",
		fontSize:"21px",
		color:"#444",
		justifyContent:"space-around",
		margin:"20px",
		//backgroundColor:SYSTEM_BLUE_BACKGROUND_LIGHT,
		height:"calc(100% - 40px)",
		borderRadius:"10px",
		alignItems:'center'
	};
	
	
	
	const goSummaryFocus =() => {
		history.push('/utilisationall/-100/1');
	};
	
	const goSummaryTechnical =() => {
		history.push('/utilisationallmeeting/-100/5');
	};
	
	const goSummaryMeeting =() => {
		history.push('/utilisationallmeeting/-100/3');
	};
	
	const goSummaryAlternative =() => {
		history.push('/utilisationallmeeting/-100/4');
	};
	
	const goSummarySocial =() => {
		history.push('/utilisationallmeeting/-100/2');
	};
	
	
	
	const editorialTitle = {
	    fontSize:"22px",
	    fontWeight:700,
	    color:"rgba(0,0,0,0.75)"
	  };

	  const editorialSubtitle = {
	    fontSize:"14px",
	    marginTop:"4px",
	    color:"rgba(0,0,0,0.55)",
	    maxWidth:"700px"
	  };
	  
	  
	  const overlayStyle = {
	      position: "fixed",
	      top: 0,
	      left: 0,
	      width: "100%",
	      height: "100%",

	      background: "rgba(255,255,255,0.85)",

	      pointerEvents: "none",

	      opacity: 0,
		 zIndex:1,
	      animation: "fadeOverlay 4s ease forwards"
	    };
		
		
		//--------------------------------------------------------
		// Mobile
		//--------------------------------------------------------

		if(isMobile)
		{
		    return (
		        <MobileHomeUtilisation/>
		    );
		}


		//--------------------------------------------------------
		// Desktop
		//--------------------------------------------------------
	
	return (
			<div style={thisContainer}>
				<Header showSurveySelector = {true}/>
				<LeftMenu/>	
				<div style={overlayStyle}/>
				<div style={header}>
					<div style={titleContainer}>
						Utilisation Summary:  Average and peak day analysis
					</div>
				</div>
				<div style={mainContent}>
				<div style={{marginLeft:"330px", marginBottom:"20px"}}>
			          <div style={editorialTitle}>
			            Utilisation Summary
			          </div>
			          <div style={editorialSubtitle}>
			            Average and peak day analysis across all worksettings, highlighting overall
			            demand, pressure points and utilisation efficiency.
			          </div>
			        </div>
					<div style={headerRow}>
						<UtilisationSpaceTypeHeader
							id="1"
							color={COLOR_FOCUS}
							clickFunction={goSummaryFocus}
							title="Focus Worksettings"
							icon="desktop"
						/>
						<UtilisationSpaceTypeHeader
							id="2"
							color={COLOR_EDIT}
							clickFunction={goSummaryTechnical}
							title="Technical Spaces"
							icon="film"
						/>
						<UtilisationSpaceTypeHeader
							id="3"
							color={COLOR_MEETING}
							clickFunction={goSummaryMeeting}
							title="Meeting Rooms"
							icon="users"
						/>
						<UtilisationSpaceTypeHeader
							id="4"
							color={COLOR_ALTERNATIVE}
							clickFunction={goSummaryAlternative}
							title="Alternative Worksettings"
							icon="couch"
						/>
						<UtilisationSpaceTypeHeader
							id="5"
							color={COLOR_SOCIAL}
							clickFunction={goSummarySocial}
							title="Social Space"
							icon="utensils"
						/>
					
					</div>
					<UtilisationSummaryRow
					  index={6}
					  icon="user"
					  title="Number of Worksettings"
					  componentHeight={componentHeight}
					  values={[workstationsFocus, workstationsEdit, workstationsMeeting, workstationsAlternative, workstationsSocial]}
					/>
					
											
					<UtilisationSummaryRow
					  index={7}
					  icon="eye"
					  title="Observations"
					  componentHeight={componentHeight}
					  values={[observationsFocus, observationsEdit, observationsMeeting, observationsAlternative, observationsSocial]}
					/>
					
					<UtilisationSummaryRow
					  index={8}
					  icon="chart-area"
					  title="Average Utilisation"
					  componentHeight={componentHeight}
					  values={[averageFocus, averageEdit, averageMeeting, averageAlternative, averageSocial]}
					/>
					
					<UtilisationSummaryRow
					  index={9}
					  icon="chart-line"
					  title="Peak Utilisation"
					  componentHeight={componentHeight}
					  values={[peakFocus, peakEdit, peakMeeting, peakAlternative, peakSocial]}
					/>
					
					
			  </div>
			 <UtilisationFooter/>
			</div>
	);
}